import { useEffect } from "react";
import { useLocation } from "react-router-dom";

// Production origin (e.g. https://allurehouse.com). Absent until the final domain is
// confirmed -> every absolute-URL tag (canonical, og:url, og:image) is omitted.
export const SITE_URL = (process.env.REACT_APP_SITE_URL || "").replace(/\/$/, "");

const setMeta = (attr, key, content) => {
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!content) return el?.remove();
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
};

const setCanonical = (href) => {
  let el = document.head.querySelector('link[rel="canonical"]');
  if (!href) return el?.remove();
  if (!el) {
    el = document.createElement("link");
    el.setAttribute("rel", "canonical");
    document.head.appendChild(el);
  }
  el.setAttribute("href", href);
};

export const Seo = ({ title, description, type = "website", jsonLd, noindex = false }) => {
  const { pathname } = useLocation();
  useEffect(() => {
    const url = SITE_URL && !noindex ? `${SITE_URL}${pathname === "/" ? "/" : pathname}` : "";
    const image = SITE_URL ? `${SITE_URL}/brand/og-image.png` : "";
    document.title = title;
    setMeta("name", "description", description);
    setMeta("name", "robots", noindex ? "noindex, nofollow" : "index, follow, max-image-preview:large, max-snippet:-1");
    setMeta("property", "og:type", type);
    setMeta("property", "og:title", title);
    setMeta("property", "og:description", description);
    setMeta("property", "og:url", url);
    setMeta("property", "og:image", image);
    setMeta("property", "og:image:width", image && "1200");
    setMeta("property", "og:image:height", image && "630");
    setMeta("name", "twitter:card", image ? "summary_large_image" : "summary");
    setMeta("name", "twitter:title", title);
    setMeta("name", "twitter:description", description);
    setMeta("name", "twitter:image", image);
    setCanonical(url);
  }, [title, description, type, pathname, noindex]);

  if (!jsonLd) return null;
  return <script type="application/ld+json" data-testid="seo-jsonld" dangerouslySetInnerHTML={{ __html: JSON.stringify(jsonLd) }} />;
};
